// Actions
const CLOSE_MODAL = "CLOSE_MODAL";
const OPEN_MODAL = "OPEN_MODAL";
export type Action = {
  readonly type: string;
  readonly newOpenModal: string | null | undefined;
  meta?: Record<string, any>;
};
// Action Creators
export const closeModal = (name: string): Action => ({
  type: CLOSE_MODAL,
  newOpenModal: null,
  meta: {
    analytics: {
      type: "modal_closed",
      properties: {
        name: typeof name === "string" ? name : null,
      },
    },
  },
});
export const openModal = (name: string, trackingProperties: Record<string, any> = {}): Action => ({
  type: OPEN_MODAL,
  newOpenModal: name,
  meta: {
    analytics: {
      type: "modal_opened",
      properties: {
        name,
        ...trackingProperties,
      },
    },
  },
});
type State = string | null | undefined;

export const modalReducer = (openModal: State = null, { type, newOpenModal }: Action) => {
  switch (type) {
    case CLOSE_MODAL:
      return null;

    case OPEN_MODAL:
      return newOpenModal;

    default:
      return openModal;
  }
};
